<template>
    <div class="backToTop" v-show="showIcon" @click="backToTop">
        <div class="icon-back" id="icon">
            <img src="./arrowTOP.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "backToTop",
        data(){
            return{
                showIcon:true,
                defaultTop: 100,
                scrollTop:0,
                defaultDuration: 400,
                width:document.body.clientWidth
            }
        },
        created(){
            this.width=document.body.clientWidth
        },
        mounted(){
            window.addEventListener('scroll', this.handelScroll, false)
            window.addEventListener('resize', this.handelWidth, false)
        },
        beforeDestroy(){
            window.removeEventListener("scroll",this.handelScroll, false)
            window.removeEventListener("resize",this.handelWidth, false)
        },
        methods:{
            handelScroll () {
                this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                this.scrollTop > this.defaultTop ? this.showIcon = true : this.showIcon = false
            },
            backToTop(){
                window.requestAnimationFrame = (function(){
                    return  window.requestAnimationFrame       ||
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame    ||
                        function( callback ){
                            window.setTimeout(callback, 1000 / 60);
                        };
                })();
                var step =  this.scrollTop / (this.defaultDuration / ( 1000 / 60)) >> 0;
                var self = this
                function fn(){
                    if(self.scrollTop >= 0){
                        self.scrollTop -= step;
                        document.documentElement.scrollTop = document.body.scrollTop = self.scrollTop;
                        fn.rafTimer = requestAnimationFrame(fn);
                    }else{
                        document.body.scrollTop = 0;
                        cancelAnimationFrame(fn.rafTimer);
                    }
                }
                fn.rafTimer = requestAnimationFrame(fn)
            },
            handelWidth(){
                this.width=document.body.clientWidth
                // if(w<1300){
                //     document.getElementById("icon").style.left="1px"
                // }else {
                //     document.getElementById("icon").style.left="-19px"
                // }
            }
        }
    }
</script>

<style scoped>
    .backToTop{
        position: fixed;
        z-index: 9999;
        bottom: 100px;
        right: 40px;
        width:60px;
        height:60px;
        background:rgba(31,32,38,0.6);
        box-shadow:0px 6px 6px rgba(0,0,0,0.2);
        border-radius:50%;
        opacity:1;
    }
    .backToTop:hover{
        background:rgba(31,32,38,1);
    }
    .icon-back{
        position: relative;
        top: 16px;
        left: 1px;
    }
</style>
